
export const INFURAURL="";
export const BOREDAPEIPFS = "https://ipfs.io/ipfs/QmeSjSinHpPnmXmspMjwiXyN6zS4E9zccariGR3jxcaWtq/";
export const BAYCCONTRACT = "0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D";
export const MAXSTORYCOUNT = 150;
export const DEVWALLET = "0xE840D3AE17ff9af2dc28d2097Dd67aeB093113E0";
export const DEVAPEWALLET = "0x296df88601c8f49535f881de73684d5e2d530a71"